

























































import {Vue, Component} from 'vue-property-decorator';
import {EClickCollectType} from "@/constants/orders";
import {Action, namespace} from 'vuex-class';
import {IApiErrors, IUserData} from "@/models/ApiModels";
import {AMAZON_RETURNS_ROUTES, CLICK_AND_COLLECT_ROUTES} from "@/constants/routes";
import {initialHub, IHub, isInitialHub} from "@/models/StoreModels";
import HubSelector from "@/views/components/FormInputs/HubSelector.vue";
import TextAreaInput from "@/views/components/FormInputs/TextAreaInput.vue";
import {errorHandler} from "@/services/services";
import {stripHtmlTags} from "@/helpers/stringHelpers";
import ShipmentInput from "@/views/components/ShipmentInput.vue";
import OrderButtonLocationSize from "@/views/components/Orders/OrderButtonLocationSize.vue";


const userDataModule = namespace("userData");
const shipmentModule = namespace("shipment");

@Component({
  name: 'ClickAndCollectForm',
  components: {
    HubSelector,
    TextAreaInput,
    OrderButtonLocationSize,
    ShipmentInput,
  },
})
export default class ClickAndCollectForm extends Vue {
  @Action('sendCCToApi')
  private sendClickAndCollectEmail!: () => Promise<any>;

  @userDataModule.Getter('getProfile')
  private profile!: IUserData;

  @shipmentModule.Getter('getCCPhoneNumber')
  private ccPhoneNumber!: string;

  @shipmentModule.Getter('getCCName')
  private ccName!: string;

  @shipmentModule.Getter('getCCShopAddress')
  private ccShopAddress!: string;

  @shipmentModule.Getter('getCCSComments')
  private ccComments!: string;

  @shipmentModule.Getter('getCCHub')
  private ccHub!: IHub;

  @shipmentModule.Action('setCCPhoneNumber')
  private setCCPhoneNumber!: (el: string) => void;

  @shipmentModule.Action('setCCName')
  private setCCName!: (el: string) => void;

  @shipmentModule.Action('setCCShopAddress')
  private setCCShopAddress!: (el: string) => void;

  @shipmentModule.Action('setCCComments')
  private setCCComments!: (el: string) => void;

  @shipmentModule.Action('setCCHub')
  private setCCHub!: (el: IHub) => void;

  private errors: IApiErrors = {};

  private myError: boolean = false;
  private errorMessage: string = '';
  private isCopied: boolean = false;

  private phoneNumber: string = '';
  private clientName: string = '';
  private shopAddress: string = '';
  private comments: string = '';
  private hub: IHub = initialHub();

  private get readyToSend(): boolean {
    return this.shopAddress !== '' && this.phoneNumber !== '' && !isInitialHub(this.hub);
  }


  private created() {
    this.phoneNumber = this.profile.phone_number; // our phone number is always the same
    this.clientName = this.ccName;
    this.shopAddress = this.ccShopAddress;
    this.comments = this.ccComments;
    this.hub = this.ccHub;
  }

  private sanitizeInputs() {
    this.phoneNumber = stripHtmlTags(this.phoneNumber);
    this.clientName = stripHtmlTags(this.clientName);
    this.shopAddress = stripHtmlTags(this.shopAddress);
    this.comments = stripHtmlTags(this.comments);
  }

  private next() {
    if (this.readyToSend) {
      this.sanitizeInputs();
      this.updateValues();
      this.$router.push({name: CLICK_AND_COLLECT_ROUTES.SUMMARY});
    }
  }

  private showErrors(err: any) {
    this.$uiBus.emit("apiStatus:error");
    const errors = errorHandler.handleErrorsResponse(err, 'clickAndCollect.errors');
    Vue.set(this, 'errors', errors);
  }

  private clearErrors() {
    Vue.set(this, 'errors', {});
  }

  private removeError(e: any) {
    Vue.set(this.errors, e, '');
  }

  private goToFinish() {
    this.$router.push({ name: CLICK_AND_COLLECT_ROUTES.FINISH });
  }

  private updateValues() {
    this.setCCComments(this.comments);
    this.setCCHub(this.hub);
    this.setCCShopAddress(this.shopAddress);
    this.setCCName(this.clientName);
    this.setCCPhoneNumber(this.phoneNumber);
  }

  private selectHub(hub: IHub) {
    this.hub = hub;
  }

}
